<template>
  <VueQrcode
    class="[&_path:nth-child(2)]:stroke-on-surface-variant! [&_path:first-child]:fill-transparent!"
    :value="link"
    tag="svg"
    :options="{ margin: 0 }"
  />
</template>

<script lang="ts" setup>
import VueQrcode from '@chenfengyuan/vue-qrcode'

interface Props {
  link: string
}

const { link } = defineProps<Props>()
</script>
